import React from 'react';
import { Icon } from './Icon.js';
export const IconMenuLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.75,9.75H2.25c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75H15.75c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M15.75,4.5H2.25c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75H15.75c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M8.25,15H2.25c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h6c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconMenuLeftFill18.js.map